import { isDefined } from '@grandvisionhq/utils';
import { getIsAvailableForSubscription } from './get-is-available-for-subscription.js';
import { getSubscriptionDeliveryIntervals } from './get-subscription-delivery-intervals.js';

/**
 * Maps the potential subscription properties of a cart line item.
 * These properties are only available for regular products and contact lenses.
 */ const mapSubscriptionProperties = (serverLineItem, subscriptionIntervalsFallback)=>{
    var ref, ref1;
    if (serverLineItem.__typename === 'LineItemBundle') {
        return {
            isSubscription: false,
            subscriptionDetails: undefined,
            convertToSubscription: undefined
        };
    }
    const isSubscription = ((ref = serverLineItem.typeDetails) === null || ref === void 0 ? void 0 : ref.isSubscription) || false;
    const subscriptionDetails = ((ref1 = serverLineItem.typeDetails) === null || ref1 === void 0 ? void 0 : ref1.subscriptionDetails) ? {
        deliveryInterval: serverLineItem.typeDetails.subscriptionDetails.deliveryInterval
    } : undefined;
    const isAvailableForSubscription = getIsAvailableForSubscription(serverLineItem.variant);
    const subscriptionIntervals = getSubscriptionDeliveryIntervals(serverLineItem, subscriptionIntervalsFallback, isAvailableForSubscription, isSubscription);
    const convertToSubscription = isDefined(subscriptionIntervals) ? {
        subscriptionIntervals
    } : undefined;
    return {
        isSubscription,
        subscriptionDetails,
        convertToSubscription
    };
};

export { mapSubscriptionProperties };
//# sourceMappingURL=map-subscription-properties.js.map
